import * as React from 'react';
import {useState, useEffect} from 'react';
import {zip, intersection} from 'ramda';
import ListGroup from 'react-bootstrap/ListGroup';
import {PanelContext} from 'react-popup-context';
import Picker from './product-picker';
import {product as Product} from 'ka-erp-data';
import {ArrowLeft} from '../common/btns';
import * as api from '../api';
import {PromiseType, ItemType} from '../../lib/utils';

const css = require('./product-categories.css').default;
const headerCss = require('../common/header.css').default;

export default function({ctx, products, onDone}: {
    ctx: PanelContext,
    products: product[],
    onDone: (codes: string[]) => void,
}) {
    const [categories, setCategories] = useState<category[]>([]);

    useEffect(() => {
        api.productCategory.get().then(setCategories);
    }, []);

    const types: ptype[] = ['單冊講義', '複習講義', '單冊卷', '複習卷', '簿本'];
    const grps = types.map(type => categories.filter(i => category.type(i) === type));

    return (
    <>
        <div id={headerCss.header}>
            <ArrowLeft width={25} height={25} onClick={() => ctx.close()}/>
            <div>選擇產品類別</div>
        </div>
        <div>
            {(() => {
                return zip(types, grps)
                .map(([type, categories]) =>
                    <List key={type} ctx={ctx} name={type} categories={categories} products={products} onDone={onDone}/>);
            })()}
        </div>
    </>);
}

function List({ctx, name, categories, products, onDone}: {
    ctx: PanelContext,
    name: string,
    categories: category[],
    products: product[],
    onDone: (codes: string[]) => void,
}) {
    function pick(tags: string[]) {
        ctx.popup(<Picker
            products={products.filter(match)}
            onDone={codes => {
                ctx.close();
                onDone(codes);
            }}
        />);
        function match(product: product) {
            return intersection(Product.tags(product), tags).length === tags.length;
        }
    }

    return (
    <div className={css.category}>
        <div className={css.title}>{name}</div>
        <ListGroup>
            {(() => {
                return categories.map(i => <ListGroup.Item key={i.name} onClick={() => pick(i.tags)}>{i.name}</ListGroup.Item>);
            })()}
        </ListGroup>
    </div>);
}

namespace category {
    export function type(cate: category) {
        if (cate.name.includes('聯絡簿')) {
            return '簿本' as const;
        } else if (cate.name.includes('卷') && cate.name.includes('單冊')) {
            return '單冊卷';
        } else if (cate.name.includes('複習卷')) {
            return '複習卷';
        } else if (cate.name.includes('單冊') || cate.name.includes('新講義')) {
            return '單冊講義';
        } else {
            return '複習講義';
        }
    }
}

type product = {
    code: string,
    name: string,
    memo: string | null,
}

type category = ItemType<PromiseType<ReturnType<typeof api.productCategory.get>>>;
type ptype = ReturnType<typeof category.type>;
